import { isFuture, parse } from "date-fns";
import { axiosInstance } from "../client";
import { AnalyticsDataType } from "@/pages/admin/analytics/types/AnalyticsDataType.interface";
import { MIME_TYPE_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { AnalyticsData } from "@/pages/admin/analytics/types/AnalyticsData.interface";

interface AnalyticsQueryParams {
  analyticsDataType: AnalyticsDataType;
  from: string | null;
  to: string | null;
}

export const fetchAnalyticsData = async ({
  analyticsDataType,
  from,
  to,
}: AnalyticsQueryParams): Promise<AnalyticsData> =>
  axiosInstance
    .get(
      `/data-analytics/${analyticsDataType}?start=${from ? from : "first day of January"}${to && !isFuture(parse(to, "yyyy-MM-dd", new Date())) ? "&end=" + to : ""}`,
      { headers: { Accept: MIME_TYPE_JSON } },
    )
    .then((response) => {
      return { analyticsDataType, ...response.data };
    });
